import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    listLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
  },
  actions: {
    async new({ commit }, payload) {
      let returnData = {};
      await api
        .post("businessStarSources", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
    async starByQuestionOption({ commit }, payload) {
      let returnData = {};
      await api.post('/businessStarSources/actionByQuestionOption', payload).then(response => {
        if (response.data.Result == "Success") {
          returnData = {
            Result: "Success",
            Response: response.data
          };
        } else {
          returnData = {
            Result: "Failed",
            Response: response.data
          };
        }
      }).catch(err => {
        returnData = {
          Result: "Error",
          Response: err
        };
      });
      return returnData;
    },
    async remove({ commit }, payload) {
      let returnData = {};
      await api
        .post("businessStarSources/remove", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
  }
}
